import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as Utils from "../../commons/utils/Utils";
import { Table, TableContainer, TableHead, TableRow, TableBody, Tooltip } from "@material-ui/core";
import { StyledTableCell } from "../../commons/utils/TableStyles";
import Security from '../../commons/security/Security'

const ClasesGrid = (props) => {
  const [redirectTo, setRedirectTo] = useState(null);
  const [loading, setLoading] = useState(null);
  const [clases, setClases] = useState(null);

  useEffect(() => {
    if (Security.hasPermission('MOVILES_LISTAR')) {
      setLoading(true);
      // Fetch Clases
      fetchClases();
    } else {
      setRedirectTo('/error');
    }
  }, []);

  const fetchClases = () => {
    Utils.getData("/llanta-modelo-clases")
      .then((res) => {
        setClases(res);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteClase = (id) => {
    Utils.deleteData("/llanta-modelo-clases/" + id)
      .then((res) => {
        fetchClases();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {redirectTo && <Redirect push to={redirectTo} />}
      <div className="card">
        <div className="card-content">
          <div className="card-body">
            <div style={{ marginBottom: "-20px" }}>
              <Tooltip
                title={props.intl.formatMessage({
                  id: "clasesGrid.button.label_add",
                  defaultMessage: "Agregar",
                })}
                arrow
                placement="right"
              >
                <div
                  className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                  onClick={() => setRedirectTo(props.match.url + "/add")}
                >
                  <i className="ft-plus"></i>
                </div>
              </Tooltip>
            </div>
            <TableContainer>
              <Table aria-label="clases table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left"></StyledTableCell>
                    <StyledTableCell align="left">
											<FormattedMessage
												id="Nombre"
												defaultMessage="Nombre"
											/>
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage
                        id="Descripcion"
                        defaultMessage="Descripcion"
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={4} align="center">
                        <FormattedMessage
                          id="Cargando"
                          defaultMessage="Cargando"
                        />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    clases &&
                    clases.map((row) => (
                      <TableRow key={"clasesGridRow_" + row.id}> {/* NOTE: se agrega una key unica para eliminar el warning de react lanzado por consola: "Each child in a list should have a unique 'key' prop" */}
                        <StyledTableCell align="left" style={{ maxWidth: 10 }}>
                          {row.id}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.nombre}</StyledTableCell>
                        <StyledTableCell align="left">{row.descripcion ? row.descripcion : ""}</StyledTableCell>
                        <StyledTableCell align="right" style={{ maxWidth: 50 }}>
                          <div className="d-flex justify-content-end">
                            <button
                              className="btn btn-sm btn-icon btn-dt-grid text-success p-0 mx-1"
                              onClick={() => setRedirectTo(props.match.url + "/" + row.id)}
                            >
                              <Tooltip
                                title={props.intl.formatMessage({
                                  id: "clasesGrid.button.label_view",
                                  defaultMessage: "Ver",
                                })}
                                arrow
                              >
                                <i className="fa fa-search fa-xs"></i>
                              </Tooltip>
                            </button>
                            <button
                              className="btn btn-sm btn-icon btn-dt-grid text-success p-0 mx-1"
                              onClick={() => setRedirectTo(props.match.url + "/" + row.id + "/edit")}
                            >
                              <Tooltip
                                title={props.intl.formatMessage({
                                  id: "clasesGrid.button.label_edit",
                                  defaultMessage: "Editar",
                                })}
                                arrow
                              >
                                <i className="fa fa-pencil fa-xs"></i>
                              </Tooltip>
                            </button>
                            <button
                              className="btn btn-sm btn-icon btn-dt-grid text-danger p-0 mx-1"
                              onClick={() => deleteClase(row.id)}
                            >
                              <Tooltip
                                title={props.intl.formatMessage({
                                  id: "clasesGrid.button.label_delete",
                                  defaultMessage: "Eliminar",
                                })}
                                arrow
                              >
                                <i className="fa fa-trash fa-xs"></i>
                              </Tooltip>
                            </button>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(ClasesGrid);
